import { IOrganization } from "../interfaces/iOrganization";

export class Organization implements IOrganization {
    isActive: boolean = false; 
	type: string = "";
    key: string = "";;
    logo: string = "";
    name: string = "";
    role: string = "";
	imgUrl: string = "";
	city?: string = "";
	state?: string = "";
}


// WEBPACK FOOTER //
// ./static-content/private/javascripts/models/classes/organization.ts